import getHtzHostname from './getHtzHostname';

export default getHtzHostname;
